import { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import useAppStore from '../store/useAppStore';
import { Navigate } from 'react-router';

export default function ProtectedRoute({ children }) {
  // const navigate = useNavigate();
  const user = useAppStore((state) => state.user);

  // useEffect(() => {
  //   // 檢查 localStorage 中是否有用戶資料
  //   const userId = localStorage.getItem('user_id');
  //   const userName = localStorage.getItem('user_name');
  //   const compName = localStorage.getItem('comp_name');

  //   if (!userName || !compName) {
  //     // 如果沒有用戶資料，導向登入頁
  //     navigate('/login');
  //   } else if (!user.isLoggedIn) {
  //     // 如果 Zustand store 中沒有登入狀態，但 localStorage 有資料，則更新 store
  //     setUser({
  //       id: userId,
  //       name: userName,
  //       company: compName,
  //       isLoggedIn: true
  //     });
  //   }
  // }, [navigate, user.isLoggedIn, setUser]);

  // 如果沒有登入 redirect到登入畫面
  if (!user.isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
